<div class="page-container min-h-0 flex-1 gap-6 overflow-hidden">
  <app-page-header
    class="shrink-0"
    title="System variables"
    description="Built-in camelCase keys you can use in forms. Examples show typical output shapes." />

  <div class="min-h-0 flex-1 overflow-y-auto pb-8">
    <div class="flex flex-col gap-8">
      @for (section of sections; track section.title) {
        <section class="flex flex-col gap-3">
          <div class="flex flex-col gap-1">
            <h2 class="text-base font-semibold text-neutral-900">
              {{ section.title }}
            </h2>
            <p class="text-sm text-neutral-500">{{ section.description }}</p>
          </div>

          <div
            class="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
            <ul class="divide-y divide-neutral-100">
              @for (variable of section.variables; track variable.key) {
                <li
                  class="flex flex-col gap-2 px-4 py-3.5 sm:flex-row sm:items-start sm:justify-between sm:gap-6">
                  <div class="flex items-center gap-2">
                    <code
                      class="inline-flex w-fit shrink-0 rounded-md bg-neutral-100 px-2.5 py-1 font-mono text-sm font-medium text-primary-800">
                      {{ variable.key }}
                    </code>
                    <button
                      type="button"
                      class="inline-flex shrink-0 cursor-pointer items-center justify-center rounded p-1 text-neutral-500 transition hover:bg-neutral-100 hover:text-neutral-800"
                      aria-label="Copy {{ variable.key }}"
                      (click)="copyKey(variable.key)">
                      <app-svg-icon
                        src="assets/icons/content-copy.svg"
                        [size]="16" />
                    </button>
                  </div>
                  <div
                    class="flex min-w-0 flex-1 flex-col gap-1.5 sm:items-end sm:text-right">
                    <p class="text-sm text-neutral-600">
                      {{ variable.description }}
                    </p>
                    <p class="text-xs text-neutral-500">
                      Example
                      <code
                        class="ml-1 inline-flex max-w-full truncate rounded-md bg-slate-50 px-2 py-0.5 font-mono text-xs font-medium text-slate-800">
                        {{ variable.exampleLabel }}
                      </code>
                    </p>
                  </div>
                </li>
              }
            </ul>
          </div>
        </section>
      }
    </div>
  </div>
</div>
